import { useEffect, useReducer, useState } from "react";
import { venueService } from "services/venueService";
import { errorAlert, successAlert } from "utils/alertHandler";

const { REACT_APP_DEFAULT_VENUE_ID } = process.env;

const SET_CURRENT_LIST = "SET_CURRENT_LIST";

function reducer(state: any, action: any) {
  if (action.type === SET_CURRENT_LIST) {
    return {
      list: action.payload,
    };
  }
  throw Error("Unknown action.");
}

export default function useProfileBookings() {
  const [tabIndex, setTabIndex] = useState<number>(0);
  const [offset, setOffset] = useState<number>(0);

  const [minHourBeforeCancel, setMinHourBeforeCancel] = useState<number>(48);
  const [credentials, setCredentials] = useState<any>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [isEnd, setIsEnd] = useState<boolean>(false);

  const [state, dispatch] = useReducer(reducer, { list: [] });

  const _onPressShowMore = () => {
    setIsLoading(true);
    setOffset((prev) => prev + 5);
  };

  const _onCancelBooking = async (bookingId: number) => {
    try {
      const result = await venueService.cancelVenueBooking(bookingId);

      if (!result) throw new Error("Failed to cancel booking");

      successAlert("Booking has been cancelled successfully");

      window.location.reload();
    } catch (error: any) {
      errorAlert(error?.message);
    }
  };

  const getVenueBookings = async () => {
    try {
      const limit = 5;
      let type = 1;

      switch (tabIndex) {
        case 0:
          type = 1;
          break;
        case 1:
          type = 2;
          break;
        case 2:
          type = 0;
          break;
      }

      const result = await venueService.getVenueBookingsByVenueIdAndUserId(Number(REACT_APP_DEFAULT_VENUE_ID), {
        filter: `[vb.status:eq:${type}]`,
        sort_by: "vb.venue_booking_id",
        order: "desc",
        limit: limit,
        offset: offset,
      });

      if (!result) {
        dispatch({ type: SET_CURRENT_LIST, payload: [] });
      } else {
        if (result.length < 1) {
          setIsEnd(true);
        } else {
          if (state.list?.length > 0) {
            if (state.list[0].status !== result[0].status) {
              dispatch({ type: SET_CURRENT_LIST, payload: result });
            } else {
              dispatch({ type: SET_CURRENT_LIST, payload: state.list.concat(result) });
            }
          } else {
            dispatch({ type: SET_CURRENT_LIST, payload: result });
          }
        }
      }

      setIsLoading(false);
    } catch (error: any) {
      errorAlert(error?.message);
      setIsLoading(false);
    }
  };

  const getVenueSettings = async () => {
    try {
      const result = await venueService.getVenueByVenueId(Number(REACT_APP_DEFAULT_VENUE_ID));

      if (!result || result?.length < 1) return;

      const minTimeAllowCancel = result[0]?.timer_allow_cancel ?? 48;

      setMinHourBeforeCancel(minTimeAllowCancel);
      setCredentials({
        is_enable_password: result[0]?.is_enable_password ?? false,
        timer_display_password: result[0]?.timer_display_password ?? 0,
        password: result[0]?.password ?? "",
      });
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    (async () => {
      await getVenueSettings();
    })();
  }, []);

  useEffect(() => {
    getVenueBookings();
  }, [offset]);

  useEffect(() => {
    dispatch({ type: SET_CURRENT_LIST, payload: [] });
    setOffset(0);
    setIsEnd(false);
    getVenueBookings();
  }, [tabIndex]);

  return { isLoading, minHourBeforeCancel, credentials, currentList: state.list, isEnd, setTabIndex, _onCancelBooking, _onPressShowMore };
}
